import { produce } from 'immer'
import { IShowInformation } from './types'

const INITIAL_STATE = {
  showInformation: true,
}

export default function user(state: IShowInformation = INITIAL_STATE, action): any {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@showInformation/CHANGE_INFORMATION': {
        draft.showInformation = action.payload
        break
      }

      default:
    }
  })
}
